<tt-page>
    <tt-project-process [params]="params" (submit)="state.back()"></tt-project-process>
</tt-page>
